import { render, staticRenderFns } from "./MessagesSection.vue?vue&type=template&id=a4bdc962&scoped=true&"
import script from "./MessagesSection.vue?vue&type=script&lang=js&"
export * from "./MessagesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bdc962",
  null
  
)

export default component.exports